import { QueryObserverOptions } from "@tanstack/react-query"

import { TotpConfirmRequest } from "@shared/zod/schemas/requests/auth"
import { MfaStatusResponse, TotpSetupResponse } from "@shared/zod/schemas/responses/auth"
import { DefaultResponse } from "@shared/zod/schemas/responses/common"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

// Sets defaults used in `buildApiFromServices`
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: 5 * 60 * 1000, // 5 minutes
}

export const mfaStatus = async (): Promise<MfaStatusResponse> => {
  const resp = await axiosAuth({
    url: "/auth/mfa",
    method: "get",
  })
  return resp.data
}

export const totpSetup = async (): Promise<TotpSetupResponse> => {
  const resp = await axiosAuth({
    url: "/auth/totp/setup",
    method: "get",
  })
  return resp.data
}

export const totpConfirm = async (data: TotpConfirmRequest): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: "/auth/totp/confirm",
    method: "post",
    data,
  })

  return resp.data
}
